// Func = limiting Scope for this file
var lastScrollTop = 0;
(function() {

    $(document).ready(function() {

        //Call function with browser is resized.
        // $(window).resize(function (event) {
        // 	resizeWindow();
        // });
        // resizeWindow();

        //Acts when scroll down page.
        // $(window).scroll(function (event) {
        // 	scrollDown();
        // });

        // Main Nav Dropdown
        $("#primary-nav li").hover(function() {
            $(this).addClass("hover");
            $('ul.submenu', this).fadeIn(200);
        }, function() {
            $(this).removeClass("hover");
            $('ul.submenu', this).fadeOut(200);
        });

        // Map: Return to previous page button. Change body id to match map template's name.
        //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

        // RESTAURANT MENUS FILTER
        document.querySelectorAll('.restMenus_filter button').forEach((btn, i) => {
            btn.addEventListener('click', _ => {
                document.querySelectorAll('.restMenus_filter button').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');

                document.querySelectorAll('.restMenus_item').forEach(room => {
                    room.classList.remove('active');
                    if (btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag) {
                        room.classList.add('active');
                    }
                });
            });

            if (i === 0) btn.click();
        });
    });

    window.onload = function() {
        /*this function add a class to header when scroll down the page
        /* and change the logo by a new file if needed depending of mockup
        */
        if (!document.getElementById('landing-booking')) {
            scrollDownAction(20, 'scroll');
        }
        scrollW();
        window.addEventListener('scroll', function() {
            scrollW();
        })
    };
    if (document.getElementsByClassName('footer') != null) {
        var submitSignUp = document.getElementById("email-signup").getElementsByClassName("signup-btn ")[0];
        submitSignUp.setAttribute('aria-label', 'Subscribe to our email database');
    }


}());

function scrollW() {
    //check scroll down or up for header styles
    let st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > 80) {
        if (st > lastScrollTop) {
            // downscroll code
            if (!document.getElementById('header').classList.contains('down')) {
                document.getElementById('header').classList.add('down');
                document.getElementById('header').classList.remove('up');
            }
        } else {
            // upscroll code
            if (!document.getElementById('header').classList.contains('up')) {
                document.getElementById('header').classList.add('up');
                document.getElementById('header').classList.remove('down');
            }
        }
    } else {
        if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
            document.getElementById('header').classList.remove('up');
            document.getElementById('header').classList.remove('down');
        }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

//script food menu 
document.querySelectorAll('.js-menu-tab').forEach((btn) => {
    btn.addEventListener('click', _ => {
        $('.js-menu-tab.active').removeClass('active');
        $(btn).addClass('active');
        $('.quad-menus__menu-content.active').removeClass('active');
        var tabNumber = $(btn).attr('data-menuid');
        var tabToOpen = ".quad-menus__menu-content[data-menuid='" + tabNumber + "']";
        $(tabToOpen).addClass('active');
        $('.quad-menus__tabs-image.active').removeClass('active');
        var imgToOpen = ".quad-menus__tabs-image[data-menuid='" + tabNumber + "']";
        $(imgToOpen).addClass('active');
        $('.name-bg.active').removeClass('active');
        var wordToOpen = ".name-bg[data-menuid='" + tabNumber + "']";
        $(wordToOpen).addClass('active');
    });
});

/*Element added by ADA */
$('input#adults').each(function() {
    $(this).attr('title', 'adults');
});
$('textarea').removeAttr('aria-labelledby');

document.addEventListener("DOMContentLoaded", function() {
    if (window.location.href.indexOf("#fancy-image-16447") > -1) {
        document.querySelector('[href="#fancy-image-16447"]').click();
    }
})
